namespace JupitersChoice {
    export class BigWinBackground extends Sapphire.Container {

        @inject('AssetCache') _assetCache: Sapphire.AssetCache;
        @inject('GameStage') _gameStage: Sapphire.GameStage;

        private _data: Sapphire.DataHelper;

        private _backGround1: PIXI.Sprite;
        private _backGround2: PIXI.Sprite;
        
        private _currentFront:number = 2;

        constructor(){
            super();
        }

        construct(data: any): void{
            this._data = new Sapphire.DataHelper(data);

            this._backGround1 = new PIXI.Sprite();
            this._backGround2 = new PIXI.Sprite();

            this.addChild(this._backGround1);
            this.addChild(this._backGround2);
            this._backGround1.visible = false;
            this._backGround2.visible = false;

            this.updateLayout();
        }

        setOrientation(orientation: string): void {
            this._data.orientation = orientation;
            this.updateLayout();
        }

        private updateLayout(){
            this.x = this._data.get('x',this.x);
            this.y = this._data.get('y',this.y);
            
            var scale = this._data.get('scale',{x:1,y:1});
            this.scale.set(scale.x,scale.y);

            var pivot = this._data.get('pivot',{x:0,y:0});
            this.pivot = new PIXI.Point(this.width*pivot.x,this.height*pivot.x);
        }

        init(level: string): void{
            this.switchSprite(level,false);
        }

        private performSwitch(container1: PIXI.Sprite,container2: PIXI.Sprite, animate: boolean, duration?: number) {
            //move it to the front.
            if(this.children.indexOf(container1) > this.children.indexOf(container2)){
                this.swapChildren(container1,container2);
            };
            container1.visible = true;
            container1.pivot = new PIXI.Point(container1.width / 2, container1.height / 2);

            if(animate){
                if(typeof duration == "undefined"){
                    duration = this._data.get('duration',1);
                }
                container1.alpha = 0;
                TweenMax.to(container1,duration,{
                    alpha:1,
                    ease:Quad.easeInOut
                });
                TweenMax.to(container2,duration,{
                    alpha:0,
                    ease:Quad.easeInOut,
                    onComplete: () => {
                        container2.visible = false;
                        container2.alpha = 1;
                    }
                });
            }else{
                container2.visible = false;
            }
        }

        switchSprite(packName: string, animate: boolean = true, duration?: number){
            var textureInfo: string[] = this._data.get(packName+'Frames');
            if(this._currentFront == 2){
                this._backGround1.texture = this._assetCache.getTexture(textureInfo[0],textureInfo[1],textureInfo[2]);
                if(textureInfo[3]){
                    this._backGround1.x = textureInfo[3]["x"];
                    this._backGround1.y = textureInfo[3]["y"];
                }else{
                    this._backGround1.x = 0;
                    this._backGround1.y = 0;
                }
                this.performSwitch(this._backGround1,this._backGround2,animate,duration);
                this._currentFront = 1;
            }else{
                this._backGround2.texture = this._assetCache.getTexture(textureInfo[0],textureInfo[1],textureInfo[2]);
                if(textureInfo[3]){
                    this._backGround2.x = textureInfo[3]["x"];
                    this._backGround2.y = textureInfo[3]["y"];
                }else{
                    this._backGround2.x = 0;
                    this._backGround2.y = 0;
                }
                this.performSwitch(this._backGround2,this._backGround1,animate,duration);
                this._currentFront = 2;
            }
        }

    }
}